import i18next from 'i18next'
import { posStatusTabKeys} from '@/constants'

export const getPOSPaymentTabs = () => posStatusTabKeys
    .map((status) => ({
        title: status ? i18next.t(`enums:posPaymentStatus.${status}`, { defaultValue: status }) : '',
        key: status
    }))
